var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"justify-center align-center"},[_c('v-col',{attrs:{"cols":_vm.$vuetify.breakpoint.mdAndUp ? 7 : 12}},[_c('operatn-not-found',{staticClass:"operatn-not-found"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }